import { render, staticRenderFns } from "./AppShape.vue?vue&type=template&id=c5400084&"
import script from "./AppShape.vue?vue&type=script&lang=js&"
export * from "./AppShape.vue?vue&type=script&lang=js&"
import style0 from "./AppShape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports